import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';

export function ContactThankYouPage() {
  useEffect(() => {
    console.log('Redirecting from /contact/thank-you to /thank-you');
  }, []);

  return <Navigate to="/thank-you" replace />;
}